import Link from 'ui/atoms/link';
import styled from 'styled-components';
import Button from 'src/ui/atoms/button';

export const TableCellContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 0.2rem;
`;

export const TableCellContentCentered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.2rem;
`;

export const TableCellContentButton = styled(Button)`
  padding: 0px;
`;

export const InlineContent = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DownloadIcon = styled(Link)`
  padding: 0px;
`;
